import { type UserProfile } from '../onboardingStore';

export interface ContextualHintDefinition {
  id: string;
  /** Route path this hint appears on */
  route: string;
  /** CSS selector for the target element */
  targetSelector: string;
  placement: 'top' | 'bottom' | 'left' | 'right';
  title: string;
  content: string;
  /** Delay in ms before showing (default 1000) */
  delay?: number;
  /** Only show for these profiles (null = all) */
  requiredProfile?: UserProfile[];
}

export const CONTEXTUAL_HINTS: ContextualHintDefinition[] = [
  {
    id: 'editor-view-modes',
    route: '/editor',
    targetSelector: '[data-onboarding="view-mode-toggle"]',
    placement: 'bottom',
    title: 'Multiple Views',
    content:
      'Switch between Code, Cards, and Table views to edit your model in the way that suits you best.',
  },
  {
    id: 'hvac-auto-detect',
    route: '/hvac',
    targetSelector: '[data-onboarding="hvac-auto-detect"]',
    placement: 'bottom',
    title: 'Auto-Detect',
    content:
      'Envelop can auto-detect HVAC systems from your IDF and display them as a visual graph.',
  },
  {
    id: 'plant-loops',
    route: '/plant',
    targetSelector: '[data-onboarding="plant-loop-tabs"]',
    placement: 'bottom',
    title: 'Plant Loops',
    content: 'Design chilled water, hot water, and condenser loops visually.',
  },
  {
    id: 'schedule-templates',
    route: '/schedules',
    targetSelector: '[data-onboarding="schedule-templates"]',
    placement: 'bottom',
    title: 'Templates',
    content: 'Import common schedule patterns like occupancy or setpoints to save time.',
  },
  {
    id: 'geometry-controls',
    route: '/geometry',
    targetSelector: '[data-onboarding="geometry-canvas"]',
    placement: 'top',
    title: '3D Controls',
    content: 'Click and drag to orbit. Scroll to zoom. Right-click to pan.',
  },
  {
    id: 'sim-weather',
    route: '/simulate',
    targetSelector: '[data-onboarding="weather-selector"]',
    placement: 'bottom',
    title: 'Weather File',
    content: 'Select a weather file for your location. This is required before running a simulation.',
  },
];

export function getHintsForRoute(route: string): ContextualHintDefinition[] {
  return CONTEXTUAL_HINTS.filter((h) => h.route === route);
}
